import { useTranslation } from 'react-i18next'

import { Skeleton } from '../../../Skeleton'
import Text from '../../../Text'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_CHART_METRIC,
  QA_NAME_DASHBOARD_BIRDVIEW_CHART_PERIOD,
} from '../../DashboardBirdview.constants.qa'
import { BirdviewChartControlSelect } from '../BirdviewChartControlSelect'

import * as styles from './BirdviewChartCardControls.module.css'

function BirdviewChartCardControls({
  asOfNowKey = 'DashboardBirdview.ChartAsOfNowKey',
  isLoading,
  metric,
  metricOptions,
  period,
  periodOptions,
  onSelectMetric,
  onSelectPeriod,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.controls}>
      {isLoading ? (
        <>
          <Skeleton className={styles.skeleton} />
          {metric ? <Skeleton className={styles.skeleton} /> : null}
        </>
      ) : (
        <>
          {period ? (
            <BirdviewChartControlSelect
              options={periodOptions}
              qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_PERIOD}
              value={period}
              onSelect={onSelectPeriod}
            />
          ) : (
            <Text isSecondary className={styles.asOfNow}>
              {t(asOfNowKey)}
            </Text>
          )}
          {metric ? (
            <BirdviewChartControlSelect
              options={metricOptions}
              qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_METRIC}
              value={metric}
              onSelect={onSelectMetric}
            />
          ) : null}
        </>
      )}
    </div>
  )
}

export default BirdviewChartCardControls
